



















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import MixinDialog from '@/plugins/podolib/services/helper/mixins/dialog';

import { TForm } from '@/plugins/podolib/lib/types';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TSoles } from '@/plugins/podolib/services/entities/EntitySoles';
import { ValidationProvider } from 'vee-validate/dist/types/components/Provider';
import { Severity } from '@sentry/types';

type TFields = {
  abbr: {
    value: string;
  };
};

interface IEquipmentsSolesDelete extends MixinDialog {
  _open(solesPair: TEntity<TSoles>): void;
}

@Component<IEquipmentsSolesDelete>({
  created() {
    this.$pdc.bus!.on('equipments:soles:delete', this._open);
  },
  beforeDestroy() {
    this.$pdc.bus!.off('equipments:soles:delete', this._open);
  },
})
export default class EquipmentsSolesDelete extends MixinDialog {
  $refs!: {
    observer: InstanceType<typeof ValidationProvider>;
    form: any;
  };
  form: TForm<TFields> = {
    fields: {
      abbr: {
        value: '',
      },
    },
    pending: false,
    error: null,
    success: false,
  };
  solesPair: TEntity<TSoles> = null!;

  @Watch('dialog')
  onDialogChanged(state: boolean) {
    if (state) {
      // Populate form
      this.form.fields.abbr.value = '';
      // Reset flags
      this.form.success = false;
      this.form.error = null;
    }
  }
  @Watch('form.fields', { deep: true })
  onFormFieldsDeeplyChanged(newFormFields: TFields) {
    // To avoid flash css switch
    if (!this.dialog) return;
    // Reset flags
    this.form.success = false;
    this.form.error = null;
  }

  _open(solesPair: TEntity<TSoles>) {
    this.solesPair = solesPair;

    this.open();
  }
  async deleteSolesPair() {
    const _solesPairShadow = Object.assign({}, this.solesPair);
    try {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      // Reset flags
      this.form.success = false;
      this.form.error = null;
      // Set 'pending' flag
      this.form.pending = true;
      // Try to patch the station ...
      await this.$pdc.repository!.emitCommand('unassign soles', {
        abbr: _solesPairShadow.abbr,
      });
      // Analytics
      this.$pdc.analytics?.actions.trackSuccess('Insole Deleted', {
        abbr: _solesPairShadow.abbr,
      });
      this.form.success = true;
    } catch (e) {
      // Analytics
      this.$pdc.analytics?.actions.trackFailure('Insole Deleted', e, {
        abbr: _solesPairShadow.abbr,
      });
      // Set 'error' flag
      this.form.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    } finally {
      // Reset 'pending' flag
      this.form.pending = false;
    }
  }
  clear() {
    this.$refs.form.reset();
    requestAnimationFrame(() => {
      (this.$refs.observer as Vue & { reset: () => void }).reset();
    });
  }
  close() {
    this.clear();
    this.dialog = false;
  }
  closeDialog() {
    if (!this.form.success) this.clear();
    this.dialog = false;
  }
}
